import { render, staticRenderFns } from "./IndustryPage.vue?vue&type=template&id=765ccbfd&scoped=true"
import script from "./IndustryPage.vue?vue&type=script&lang=js"
export * from "./IndustryPage.vue?vue&type=script&lang=js"
import style0 from "./IndustryPage.vue?vue&type=style&index=0&id=765ccbfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765ccbfd",
  null
  
)

export default component.exports